import styled from 'styled-components'
import { theme } from '../../styles'

export const Paymethod = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 14px 16px;
  border-radius: ${theme.raio.md};
  background: ${theme.cores.accentTint};
  color: ${theme.cores.inkDeep};
  margin-bottom: 18px;
`

export const PaymethodIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: ${theme.cores.accent};
  color: ${theme.cores.white};
  flex-shrink: 0;
`

export const PaymethodBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  .k {
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: ${theme.cores.inkSoft};
  }

  b {
    color: ${theme.cores.inkDeep};
    font-size: 15px;
  }
`

export const Listnote = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 12px;
  padding: 9px 12px;
  border-radius: 9px;
  background: ${theme.cores.paperAlt};
  border: 1px solid ${theme.cores.line};
  color: ${theme.cores.inkSoft};
  font-size: 12.5px;

  svg {
    flex: none;
  }

  b {
    color: ${theme.cores.navy};
  }
`

export const ItemList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const Itemrow = styled.div`
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 14px;
  border: 1.5px solid ${theme.cores.lineStrong};
  border-radius: 12px;
  background: ${theme.cores.paperAlt};
  transition: border-color 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;

  ${( { $primary } ) => ( $primary
    ? `background: ${theme.cores.accentTint}; border-color: #EAD4B6;`
    : '' )}

  ${( { $drag } ) => ( $drag
    ? `cursor: grab;
       &:active { cursor: grabbing; }`
    : '' )}

  ${( { $dragging } ) => ( $dragging ? 'opacity: 0.45;' : '' )}

  ${( { $validating } ) => ( $validating ? 'opacity: 0.55;' : '' )}

  ${( { $over } ) => ( $over
    ? `border-color: ${theme.cores.accent};
       box-shadow: 0 -3px 0 -1px ${theme.cores.accent} inset;`
    : '' )}

  ${theme.mobile} {
    padding: 13px 12px;
  }
`

export const ItemrowGrip = styled.span`
  flex: none;
  display: grid;
  place-items: center;
  width: 22px;
  margin-left: -4px;
  color: ${theme.cores.inkFaint};
  cursor: grab;
  transition: color 0.15s ease;

  &:hover {
    color: ${theme.cores.accent};
  }

  ${theme.mobile} {
    display: none;
  }
`

export const OnlyDesktop = styled.span`
  ${theme.mobile} {
    display: none;
  }
`

export const OnlyMobile = styled.span`
  display: none;

  ${theme.mobile} {
    display: inline;
  }
`

export const ItemrowIcon = styled.span`
  display: grid;
  place-items: center;
  flex: none;
  width: 42px;
  height: 42px;
  border-radius: 11px;
  background: ${theme.cores.white};
  border: 1px solid ${theme.cores.line};
  color: ${theme.cores.navy};
`

export const ItemrowBody = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;

  b {
    display: block;
    font-size: 14.5px;
    color: ${theme.cores.navy};
  }

  > span {
    font-size: 12.5px;
    color: ${theme.cores.inkSoft};
  }
`

export const ItemrowTags = styled.span`
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
  margin-bottom: 4px;
`

export const ItemrowActs = styled.div`
  flex: none;
  display: flex;
  gap: 6px;
  align-self: flex-start;
`

export const IconBtn = styled.button`
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: 9px;
  border: 1.5px solid ${theme.cores.lineStrong};
  background: ${theme.cores.white};
  color: ${theme.cores.inkSoft};
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease, opacity 0.2s ease;

  &:hover:not(:disabled) {
    border-color: ${( { $danger } ) => ( $danger ? theme.cores.statusStop : theme.cores.accent )};
    color: ${( { $danger } ) => ( $danger ? theme.cores.statusStop : theme.cores.accent )};
  }

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }

  ${theme.mobile} {
    width: 40px;
    height: 40px;
  }
`

export const Tag = styled.span`
  flex: none;
  display: inline-block;
  padding: 2px 6px;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${( { $off, $validating } ) => {
    if ( $validating ) {
      return '#8A6A1F'
    }
    return $off ? theme.cores.inkFaint : theme.cores.accent
  }};
  background: ${( { $off, $validating } ) => {
    if ( $validating ) {
      return 'rgba(240, 180, 60, 0.18)'
    }
    return $off ? theme.cores.paper : theme.cores.accentTint
  }};
  border: 1px solid ${( { $off, $validating } ) => {
    if ( $validating ) {
      return '#E8C87A'
    }
    return $off ? theme.cores.lineStrong : '#EAD4B6'
  }};

  ${( { $inline } ) => ( $inline ? 'margin-left: 6px;' : '' )}
`

export const EmptyList = styled.div`
  padding: 20px;
  border: 1px dashed ${theme.cores.border};
  border-radius: ${theme.raio.md};
  color: ${theme.cores.inkSoft};
  font-size: 14px;
  text-align: center;
`

export const Hint = styled.p`
  margin: 0;
  color: ${theme.cores.inkSoft};
  font-size: 14px;
  line-height: 1.5;

  & + & {
    margin-top: 10px;
  }
`

export const MenuActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;

  button {
    width: 100%;
  }
`
